import Repository from "@/repositories/Repository";

// Verb 	    URI 	                Action 	  Route Name
// GET 	      /photos 	            index 	  photos.index
// GET 	      /photos/create 	      create 	  photos.create
// POST 	    /photos 	            store 	  photos.store
// GET 	      /photos/{photo} 	    show 	    photos.show
// GET 	      /photos/{photo}/edit 	edit 	    photos.edit
// PUT/PATCH 	/photos/{photo} 	    update 	  photos.update
// DELETE 	  /photos/{photo} 	    destroy 	photos.destroy

const resource = "/insurance_ancillaries";
export default {
  index(queryString, config = {}) {
    // get the list
    return queryString
        ? Repository.get(`${resource}?${queryString}`, config)
        : Repository.get(`${resource}`, config);
  },
  create() {
    // get the create form
    return Repository.get(`${resource}/create`);
  },
  show(id, relationString) {
    return relationString
      ? Repository.get(`${resource}/${id}/${relationString}`)
      : Repository.get(`${resource}/${id}`);
  },
  sendings(id) {
    // storico degli invii (email, SMS, stampa), dal più recente
    return Repository.get(`${resource}/${id}/sendings`);
  },
  edit(id) {
    // get the edit form
    return Repository.get(`${resource}/${id}/edit`);
  },
  store(payload) {
    // save the item
    return Repository.post(`${resource}`, payload);
  },
  update(id, payload) {
    // update the item
    return Repository.put(`${resource}/${id}`, payload);
  },
  destroy(id) {
    // delete the item
    return Repository.delete(`${resource}/${id}`);
  },
  pivot_store(id, relation, payload) {
    return Repository.post(`${resource}/${id}/pivot/${relation}`, payload);
  },
  pivot_update(id, relation, payload) {
    return Repository.put(`${resource}/${id}/pivot/${relation}`, payload);
  },
  register(id) {
    return Repository.put(`${resource}/${id}/register`);
  },
  to_collect_update(id, payload) {
    return Repository.put(`${resource}/${id}/to-collect`, payload);
  },
  // Report EXPOMON (CSV)
  report(payload) {
    // save the item
    return Repository.post(`${resource}/export`, payload);
  },
  filter_update(payload, queryString) {
    return queryString
        ? Repository.put(`${resource}/filter/update?${queryString}`, payload)
        : Repository.put(`${resource}/filter/update`, payload);
  },
  uncheck_selected() {
    // get the create form
    return Repository.put(`${resource}/uncheck-selected`);
  },
  remaining_balance(id) {
    // get the remaining balance amount for Lisapay
    return Repository.get(`${resource}/${id}/remaining-balance`);
  },
};
